import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

const initialState = {
  userDetail: null,
  language: null,
};

export const useAuth = create(
  persist(
    () => ({
      ...initialState,
    }),
    {
      name: "userDetails",
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);
